import { LIFETIME_PREMIUM_LINK } from "~/constants/socials";
import { SIGN_UP_CAMPAIGN_TOKEN_PARAM } from "~/feature/auth/constants";
import { SignUpCampaign } from "~/feature/auth/type";

export const resolveSignUpCampaign = (
  pathname: string,
  searchParams: URLSearchParams
): string | null => {
  if (pathname !== LIFETIME_PREMIUM_LINK) {
    return null;
  }

  const token = searchParams.get(SIGN_UP_CAMPAIGN_TOKEN_PARAM)?.trim();

  return token || SignUpCampaign.Lifetime;
};
